import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const withValidationMessageHOCGenerator = (Component) => {
  function WithValidationMessageHOC(props) {
    const { validateValueInput: ownerValidateValueInput } = props;
    const [validationMessage, setValidationMessage] = useState(null);
    const [isValid, setIsValid] = useState(true);
    const validateValueInput = useCallback(
      (inputValue) => {
        const result = ownerValidateValueInput ? ownerValidateValueInput(inputValue) : true;

        if (typeof result === 'object') {
          const { isValid: _isValid, validationMessage: _validationMessage, preventChange = true } = result;

          setIsValid(_isValid);
          setValidationMessage(_validationMessage);
          return _isValid || !preventChange;
        }

        setValidationMessage(null);

        return result;
      },
      [ownerValidateValueInput]
    );

    return <Component {...props} validationMessage={validationMessage} isValid={isValid} validateValueInput={validateValueInput} />;
  }

  WithValidationMessageHOC.propTypes = {
    validateValueInput: PropTypes.func,
  };

  return WithValidationMessageHOC;
};

const withValidationMessage = () => (Component) => withValidationMessageHOCGenerator(Component);

export default withValidationMessage;
